import { gql } from 'apollo-angular';

const UPLOAD_PRODUCT_ANALYSIS = gql`
  mutation analysisRequest(
    $uploadRequestId: Long!
    $headerIndex: Int!
    $sheetName: String!
    $fieldMap: [UploadFieldMapEntry]!
  ) {
    analysisRequest(
      analysisRequest: {
        uploadRequestId: $uploadRequestId
        headerIndex: $headerIndex
        sheetName: $sheetName
        fieldMap: $fieldMap
      }
    ) {
      rows
      resourceId
      failureCount
      matchedCount
      successCount
      unorderedPricingCount
      processedCount
      downloadUrl
      analysisViolations {
        alertLevel
        message
        violationCount
      }
    }
  }
`;

export default UPLOAD_PRODUCT_ANALYSIS;
